const key = 'cartId'

export const setCartIdToStorage = (cartId: string) => {
  localStorage.setItem(key, cartId)
}

export const getCartIdFromStorage = () => {
  return localStorage.getItem(key)
}

export const clearCartIdFromStorage = () => {
  localStorage.removeItem(key)
}
